import { createContext } from 'react';
import utils from 'utils';

type DownloadStatusContextProps = {
  isAnalyticsExportInProgress: boolean;
  startFileDownload: () => void;
  failFileDownload: () => void;
  startReportDownload: (openInNewTab?: boolean) => void;
  failReportDownload: () => void;
  showAnalyticsExportInProgressBanner: () => void;
  startAnalyticsExportDownload: (customMessage?: string, openInNewTab?: boolean) => void;
  failAnalyticsExportDownload: () => void;
};

export default createContext<DownloadStatusContextProps>({
  isAnalyticsExportInProgress: false,
  startFileDownload: utils.noop,
  failFileDownload: utils.noop,
  startReportDownload: utils.noop,
  failReportDownload: utils.noop,
  showAnalyticsExportInProgressBanner: utils.noop,
  startAnalyticsExportDownload: utils.noop,
  failAnalyticsExportDownload: utils.noop,
});
